import React, { Component } from "react";
import { Form, Button, Checkbox, Radio } from "semantic-ui-react";
import isEmpty from "validator/lib/isEmpty";
import matches from "validator/lib/matches";
import isEmail from "validator/lib/isEmail";
import InlineError from "../messages/InlineError";

class EditForm extends Component {
  state = {
    data: {
      activo: 0,
      ciudad: "",
      direccion: "",
      email: "",
      id: "",
      nit: "",
      nombre: "",
      telefono: "",
    },
    isLoading: true,
    errors: {},
  };

  onChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  validate = (data) => {
    const errors = {};

    if (isEmpty(data.id)) errors.id = "No puede estar en blanco.";

    if (isEmpty(data.nombre)) errors.nombre = "No puede estar en blanco.";

    if (isEmpty(data.nit)) errors.nit = "No puede estar en blanco.";

    if (!isEmail(data.email)) errors.email = "No es un correo válido.";

    return errors;
  };

  onSubmit = (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.data);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      // console.log(this.state.data);
      this.props.submit(this.state.data);
    }
  };
  _onChangeCheckbox = (e, data) => {
    const checked = data.checked ? 1 : 0;
    this.setState({
      data: { ...this.state.data, [data.name]: checked },
    });
  };
  _onChangeRadioButton = (e, data) => {
    this.setState({ data: { ...this.state.data, gender: data.value } });
  };

  componentDidMount() {
    //Pre llenado del formulario
    this.setState({
      isLoading: false,
      data: {
        ...this.state.data,
        activo: this.props.activo,
        ciudad: this.props.ciudad,
        direccion: this.props.direccion,
        email: this.props.email,
        id: this.props.id,
        nit: this.props.nit,
        nombre: this.props.nombre,
        telefono: this.props.telefono,
      },
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.id !== prevProps.id) {
      this.setState({
        isLoading: false,
        data: {
          ...this.state.data,
          nit: this.props.nit,
        },
      });
    }
  }

  onChangeCheckbox = (e, checkbox) => {
    const checked = checkbox.checked === true ? 1 : 0;
    this.setState({
      data: { ...this.state.data, approved: checked },
    });
  };

  render() {
    const { errors, data } = this.state;
    return (
      <Form onSubmit={this.onSubmit}>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.practitioner_id}>
            <label htmlFor="nit">NIT *</label>
            <input
              className="u-full-width"
              type="text"
              placeholder="Escriba su documento de identidad"
              id="nit"
              name="nit"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.nit}
            />
            {errors.nit && <InlineError text={errors.nit} />}
          </Form.Field>
          <Form.Field error={!!errors.id}>
            <label htmlFor="id">ID *</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="id"
              name="id"
              autoComplete="false"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.id}
            />
            {errors.id && <InlineError text={errors.id} />}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.names}>
            <label htmlFor="nombre">Nombre *</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="nombre"
              name="nombre"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.nombre}
            />
            {errors.nombre && <InlineError text={errors.nombre} />}
          </Form.Field>

          <Form.Field>
            <label htmlFor="activo">Habilitado</label>
            <Checkbox
              toggle
              name="activo"
              onChange={this._onChangeCheckbox}
              disabled={this.props.role === 1 ? false : true}
              checked={data.activo === 1 ? true : false}
              floated="right"
            />
          </Form.Field>
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field error={!!errors.email}>
            <label htmlFor="email">Correo Electrónico *</label>
            <input
              className="u-full-width"
              type="email"
              placeholder=""
              id="email"
              name="email"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.email}
            />
            {errors.email && <InlineError text={errors.email} />}
          </Form.Field>
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field error={!!errors.ciudad}>
            <label htmlFor="ciudad">Ciudad</label>
            <input
              className="u-full-width"
              type="text"
              placeholder="Ciudad de residencia"
              id="ciudad"
              name="ciudad"
              onChange={this.onChange}
              value={data.ciudad}
            />
            {errors.ciudad && <InlineError text={errors.ciudad} />}
          </Form.Field>
          <Form.Field error={!!errors.address}>
            <label htmlFor="direccion">Dirección</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="direccion"
              name="direccion"
              onChange={this.onChange}
              value={data.direccion}
            />
            {errors.direccion && <InlineError text={errors.direccion} />}
          </Form.Field>
          <Form.Field error={!!errors.phone}>
            <label htmlFor="telefono">Teléfono</label>
            <input
              className="u-full-width"
              type="text"
              placeholder="Teléfono fijo o celular"
              id="telefono"
              name="telefono"
              onChange={this.onChange}
              value={data.telefono}
            />
            {errors.telefono && <InlineError text={errors.telefono} />}
          </Form.Field>
        </Form.Group>
        {this.props.practitioner_id === this.props.loggedPractitioner ? (
          <div>
            <Form.Field>
              <label>Tratamiento de datos personales</label>
            </Form.Field>
          </div>
        ) : null}

        <Form.Field className="buttonRight">
          <Button
            content="Cancelar"
            type="button"
            onClick={() => this.props.cancel()}
          ></Button>
          <Button
            color="blue"
            content="Guardar"
            icon="save"
            labelPosition="right"
          />
        </Form.Field>
      </Form>
    );
  }
}

export default EditForm;
